export const CATEGORIES_BASE_PATH = 'categories';
